import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';
import Tab2 from './Tab2';
import Amortissement from '../../../../../Functions/Traitement/Amortissement';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../../Models/Pret';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import ParamsQard from '../../../../../Models/ParamsQard';
import { SimulationQardDto } from '../../../../../Models/SimulationQardDto';
import { PrintTabamount } from '../../../../../utilitaires/PrintTabamort';
import { useAgence } from '../../../../../AgenceContext';
//import "../../Assets/Styles/StyleForm.css";

const SimulationQard = () => 
{
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  
  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  // const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("");
  const [data, setData] = useState([]);
  const Branch=useAgence();
  // const navigate = useNavigate();


  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  const columns: ColumnsType<any> = [
    {
      title: 'N° écheance',
      dataIndex: 'NumeroEch',
      width: 120,
      align: 'center',
      render: (text: any) => <span style={{ fontWeight: 500, color: '#1890ff' }}>{text}</span>
    },
    {
      title: 'Date Echéance',
      dataIndex: 'DateEcheance',
      width: 150,
      align: 'center',
      render: (text: any, record: any) => (
        <span style={{ fontWeight: 500 }}>
          { record.DateEcheance?(new Date(record.DateEcheance.substring(0, 10))).toLocaleDateString("fr-FR") : ''
          }
        </span>)
    },
    {
      title: 'Capital Initial',
      dataIndex: 'CapitalInitial',
      width: 180,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500, }}>{text ? Number(text).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}</span>
    },
    {
      title: 'Amortissement',
      dataIndex: 'CapitalRembourse',
      width: 180,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500, }}>{text ? Number(text).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}</span>
    },
    {
      title: 'Capital Restant',
      dataIndex: 'CapitalRestant',
      width: 180,
      align: 'right',
      render: (text: any) => <span style={{ fontWeight: 500,}}>{text ? Number(text).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}</span>
    }
  ]


  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }


  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    setImpActive(true)
    setData([])
    form.resetFields()
    initialiazeButton()
    
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    setImpActive(true);
  }

   function AfficheButton() {
    setSbmit("Afficher")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }



  function consultTypecard()
       {
          if (form.getFieldValue("CodeQard") == null) 
          {
              SweetAlert.fire({ title: "Svp renseigner le Code du type de Qard ", icon: "warning" });
          } else 
          {
              let data = form.getFieldValue("CodeQard");
             
              if (data.length != 0) 
              {
                  setLoading(true)
  
                  let config = {
                      method: 'get',
                      maxBodyLength: Infinity,
                      url: Data.ApiUrl.ReadParamsQard,
                      headers: {
                          'CypherCodeQard': Crypter.encrypt(data),
                          'Authorization': authHeader(),
                          'Content-Type': 'application/json'
                      },
                  };
  
                  axios.request(config)
                      .then((response) => 
                       {
                          setLoading(false);
                          if (response.data) 
                          {
                              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                              // console.log(DemandVP);

                              if (res.StatutCode == 200) 
                              {
                           
                                   let  ParamsQard: ParamsQard = res.Result.Table1[0];

                                   ParamsQard.Frais=res.Result.Table2.map((x: any) => x.CODOPE);
                                  
                                   //ParamsQard.ComptesRemboursementAuto=res.Result.Table2.map((x: any) => x.IDPLAN);;
                                   form.setFieldValue("CodeFrais",ParamsQard.Frais);
                                   form.setFieldValue("MontantFrais", ParamsQard.MontantFrais);
                                   //  HandleConsult();
                                   //  console.log(ParamsQard);
                              }
                              else
                             {
                                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                              }
                          }
                          setLoading(false)
                      })
                      .catch((error) => 
                      {
                          setLoading(false);
                          console.log(error)
                          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                      });
              }
          }
      }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Information du financement
        </span>
      ),
      children: <Tab1 form={form} disabled={ajoutActve} GetTypeCard={consultTypecard} />, //form={form}
    },
      {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Frais de service
        </span>
      ),
      children: <Tab2 form={form}  />, //form={form}
    }
  ];



  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  // Aperçu : impression directe sans passer par la validation du formulaire (le rejet ne doit pas bloquer)
  const handleApercu = () => {
    const values = form.getFieldsValue(true);

    const SimulationQard: SimulationQardDto = {
      CodeSimul: values.CodeSimul,
      CodeQard: values.CodeQard,
      Montant: values.Montant,
      NombreEch: values.NombreEch,
      Periodicite: values.Periodicite,
      Numcli: values.Numcli,
      DatePremEch: values.DatePremEch,
      MontantFrais: values.MontantFrais,
      CodeUti: user.coduti,
      Nomcli: values.lib_Numcli
    };

    setLoading(true);
    SimulationQard.CodeQard = SimulationQard.CodeQard + '-' + '' + values.lib_CodeQard;
    PrintTabamount(
      user.coduti ?? '',
      user.codage ?? '',
      Branch.agence?.LIBELLE ?? '',
      Branch.agence?.BANQUE ?? '',
      Branch.agence?.TELEPH ?? '',
      Branch.agence?.NUMREG ?? '',
      Branch.agence?.LICENCE ?? '',
      Branch.agence?.NUMREG ?? '',
      Branch.agence?.BPOSTE ?? '',
      Branch.agence?.VILLE ?? '',
      user.nomuti ?? '',
      values.lib_Periodicite,
      SimulationQard,
    );
    setLoading(false);
  };

  const onFinish = async (values: any) => 
    {
    //  const SimulationQard: SimulationQardDto = values;
    //  SimulationQard.frais=values.FraisService;
    //  alert(JSON.stringify(SimulationQard))

    const SimulationQard: SimulationQardDto = {
      CodeSimul: values.CodeSimul,
      CodeQard: values.CodeQard,
      Montant: values.Montant,
      MontantCharge:values.MontantCharge,
      NombreEch: values.NombreEch,
      Periodicite: values.Periodicite,
      Numcli: values.Numcli,
      DatePremEch: values.DatePremEch,
      MontantFrais: values.MontantFrais,
      CodeUti:user.coduti,
      Nomcli: values.lib_Numcli
    };

    // alert(JSON.stringify(SimulationQard))

     let data = Crypter.encrypt(JSON.stringify(SimulationQard));
    
   if (sbmit == "Afficher") 
    {

       let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.SimulationQard,
            headers: {
              //'CypherUser': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                  if (res.StatutCode == 200) 
                  { 
                     var newData:any =  [];
                     newData.push(res.Result.Table1);
                    //  setData(newData);
                    
                    //alert(JSON.stringify(newData));
                    setData(res.Result.Table1 as any);
                    setImpActive(false);
                    setSbmit("add");
                      //HandleAnnul();
                  }
                  else {
                    // alert(JSON.stringify(res));
                     SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" }) 
                  }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            });

     }else if (sbmit == "add") {
      SweetAlert.fire({
        title: "Enregistrement de la simulation de financement",
        text: "Voulez-vous enregistrer cette simulation de Financement?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
         
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateSimulationQard,
            headers: {
              //'CypherUser': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  if (res.StatutCode == 200) 
                  { 
                    //  var newData:any =  [];
                    //  newData.push(res.Result.Table1);
                    
                    initialiazeButton();
                    form.resetFields();
                    setData([]);
                    setImpActive(false);
                     SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" }) 
                   
                  }
                  else {
                    // alert(JSON.stringify(res));
                     SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" }) 
                  }
                }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            });
        }
      })
    }
    if (sbmit == "update") {
       SweetAlert.fire({
        title: "Mise à jour de la simulation de financement",
        text: "Voulez-vous mettre à jour la simulation de Financement "+ SimulationQard.CodeSimul +' ?',
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true);
          //alert(JSON.stringify(values))
       
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateSimulationQArd,
            headers: {
              //'CypherUser': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  if (res.StatutCode == 200) 
                  { 
                    //  var newData:any =  [];
                    //  newData.push(res.Result.Table1);
                    initialiazeButton();
                    form.resetFields();
                    setData([]);
                    setImpActive(false);
                     SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" }) 
                   
                  }
                  else {
                    // alert(JSON.stringify(res));
                     SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" }) 
                  }
                }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            });
        }
      })
    }
  };
  function modif() 
  {
    modifButton()
  }

  function consult() 
  {
    // localStorage.setItem(Data.LocalVariable.reset, "1")
    //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
    let data = Crypter.encrypt(form.getFieldValue("CodeSimul"));
    let codeSimul = form.getFieldValue("CodeSimul")

    if (data.length != 0) {
      // initialiazeButton()
      setLoading(true)
      form.resetFields();
      form.setFieldValue('CodeSimul', codeSimul)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadSimulationQard,
        headers: {
          'CypherCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res);
            if (res.StatutCode == 200) 
            {
                    //  var newData:any =  [];
                    //   newData.push(res.Result.Table1);
                    //  setData(newData);
                    form.setFieldsValue(res.Result.Table2[0]);
                    // alert(JSON.stringify(res.Result.Table1[0]));
                    form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table2[0].DatePremEch));

                    setData(res.Result.Table1 as any);
                    consultTypecard();
                    cunsultButton();
                    setImpActive(false)
                // setEnregActve(false);
            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }


  

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>SIMULATION du financement Qard</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
            <div className='bG' 
            // style={{ flex: '0 0 auto' }}
            >
              <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
              <Form.Item shouldUpdate className='bouttong'>
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                    Consulter
                  </Button>
                  <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                    Ajouter
                  </Button>
                  <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={AfficheButton} htmlType="submit" block>
                    Afficher
                  </Button>
                  <Button size='large' className='bt_add'  htmlType="button" 
                  onClick={handleApercu}
                  disabled={impActive} type="ghost"  block  >
                    Aperçu 
                  </Button>
                  <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                    Modifier
                  </Button>
                  <Button size='large'   className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                    Enregistrer  
                  </Button>
                  <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                    Annuler
                  </Button>
                </Space>
              </Form.Item>
            </div>
            <div className='clientP'>
                <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              <Box display={"flex"} fontStyle="inherit" className='border-left tabElementsimFin'>
                <Spin spinning={loading}>
                  <Form disabled={true}>
                    <Table 
                      size='small' 
                      columns={columns} 
                      dataSource={data} 
                      scroll={{ y: 250 }} 
                      pagination={false}
                      bordered
                      style={{ 
                        backgroundColor: '#ffffff',
                        borderRadius: '6px'
                      }}
                      rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    />
                </Form>
                 <InputForm money notRequired disabled width={4} label='Amort' name='Montant' type='text' error='mobile' />
                </Spin>
               </Box>
              
              <div>
              </div>
            </div>
          
        </Form>
      </Spin>
    </div>
  );
}
export default SimulationQard;